import { PrimaryColor } from "node-library/dist/colors";

interface Props {
	headerTextTop: string;
	headerTextBottom: string;
	// logoUrl: string;
	imageUrl: string;
	// footerText: string;
}

export default function LoginImageCard(props: Props) {
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
			}}
		>
			<div className="common-card-header">
				<div className="typography-heading-01 login-slider-heading-01">
					<div>{props.headerTextTop}</div>
					<div
						className="typography-bold"
						style={{ color: PrimaryColor.PRIMARY_600 }}
					>
						{props.headerTextBottom}
					</div>
				</div>
				<div className="ppb-logo login-ppb-logo"></div>
			</div>
			<div
				style={{ display: "flex", justifyContent: "center", margin: "auto" }}
			>
				<img className="slider-card-image" src={props.imageUrl}></img>
			</div>
			{/* <div style={{ width: "80%" }}>
				<div className="typography-body-01"> {props.footerText}</div>
			</div> */}
		</div>
	);
}
